import type { EngineInfo } from './protocol';
import type { Color } from '../chess/ChessRules';
import type { Offer } from '../puzzle/PuzzleSessionController';
export function parseInfo(line: string): EngineInfo | undefined {
  line = line.trim();
  const multipv = line.match(/\bmultipv\s+(\d+)\b/);
  if (!line.startsWith('info ') || (multipv && Number(multipv[1]) !== 1)) return;
  const depth = Number(line.match(/\bdepth\s+(\d+)/)?.[1] ?? 0),
    score = line.match(/\bscore\s+(cp|mate)\s+(-?\d+)/);
  const pv: string[] = [];
  for (const move of line.match(/\bpv\s+(.+)$/)?.[1].split(/\s+/) ?? []) {
    if (!/^[a-h][1-8][a-h][1-8][qrbn]?$/.test(move)) break;
    pv.push(move);
  }
  if (!score) return;
  return {
    depth,
    ...(score[1] === 'cp' ? { cp: Number(score[2]) } : { mate: Number(score[2]) }),
    pv,
    bound: /\b(lowerbound|upperbound)\b/.test(line),
  };
}
export function normalizeScore(
  info: Pick<EngineInfo, 'cp' | 'mate'>,
  sideToMove: Color,
  user: Color,
) {
  const sign = sideToMove === user ? 1 : -1;
  return {
    cp: info.cp === undefined ? undefined : info.cp * sign,
    mate: info.mate === undefined ? undefined : info.mate * sign,
  };
}
export function classify(infos: EngineInfo[], side: Color, user: Color): Offer {
  const exact = infos.filter((i) => !i.bound),
    last = exact.at(-1);
  if (!last) return { kind: 'playable' };
  const score = normalizeScore(last, side, user),
    previous = exact.at(-2);
  const stable =
    last.depth >= 10 ||
    (!!previous && previous.depth !== last.depth && previous.mate === last.mate);
  const plies = score.mate === undefined ? Infinity : score.mate * 2 - (side === user ? 1 : 0);
  if (score.mate !== undefined && score.mate > 0 && plies <= 12 && stable)
    return { kind: 'mate', moves: score.mate };
  if (score.cp !== undefined && score.cp >= 300) return { kind: 'winning', cp: score.cp };
  return { kind: 'playable' };
}
